var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 111,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 0h-3L35 12c-4 1-4 7 0 9l35 16h4l34-16c4-2 4-8 0-9L72 0Zm-2 21c5 0 9-2 9-4s-4-4-9-4-9 2-9 4 4 4 9 4ZM65 39c2 1 3 3 3 5l1 48c0 4-4 6-7 5L26 83c-1 0-3-2-3-4l1-50c0-4 3-6 6-5l35 15Zm-25 4c0 3-2 6-4 6-3 0-5-3-5-6 0-4 2-6 5-6 2 0 4 2 4 6Zm13 40c2 0 4-3 4-6 0-4-2-6-4-6-3 0-5 2-5 6 0 3 2 6 5 6ZM75 44c0-2 1-4 3-5l34-13c4-1 7 1 7 5v49c0 2-1 4-3 5L81 96c-3 2-7-1-7-4l1-48Zm36 2c0 3-2 6-4 6-3 0-5-3-5-6 0-4 2-6 5-6 2 0 4 2 4 6Zm-4 29c2 0 4-3 4-6 0-4-2-6-4-6-3 0-5 2-5 6 0 3 2 6 5 6Zm-12 0c0 3-2 6-4 6-3 0-5-3-5-6 0-4 2-6 5-6 2 0 4 2 4 6Zm-4-18c2 0 4-3 4-6 0-4-2-6-4-6-3 0-5 2-5 6 0 3 2 6 5 6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetsIcon);
export default __webpack_public_path__ + "static/media/bets_icon.e7d3677e81aed9d7068fabebd793d327.svg";
export { ForwardRef as ReactComponent };